<template>
  <div class="rootDiv">
    <a-alert
      :message="result.status === 'success' ? '完成' : result.msg"
      :type="result.status"
      show-icon
      v-if="showAlert"
    />
    <div class="resultPannel" v-if="result.text">
      <p class="resultHead">描述</p>
      <h3 class="resultContent">{{ result.text }}</h3>
    </div>
    <div v-if="result.options" class="resultPannel">
      <p class="resultHead">结果图</p>
      <div
        v-for="(option, i) in result.options"
        :key="i"
        :ref="'option' + i"
        :style="{ width: '100%', height: '500px' }"
        class="resultContent"
      >
        {{ "option" + i }}
      </div>
    </div>
    <div v-if="result.table2d_values" class="resultPannel">
      <p class="resultHead">结果表</p>
      <a-table
        :columns="columns"
        :data-source="tableData"
        :scroll="{ y: 300 }"
        :pagination="{ pageSize: 40 }"
        bordered
        size="small"
        class="resultContent"
      ></a-table>
      <a-button @click="downloadTable" style="margin: 0 0 1rem 1rem">下载表格</a-button>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  props: ['result', 'showAlert'],
  data() {
    return {
      options: null,
      tableData: [],
      columns: []
    }
  },
  methods: {
    initOption() {
      for (const i in this.result.options) {
        const myChart = echarts.init(this.$refs['option' + i][0])
        myChart.setOption(this.result.options[i])
      }
    },
    initTable() {
      if (!this.result.table2d_values) {
        return ''
      }
      this.columns = []
      // eslint-disable-next-line no-array-constructor
      this.tableData = new Array(this.result.table2d_values[0].values.length)
      for (const i in this.result.table2d_values) {
        const colName = 'col' + i
        const title = this.result.table2d_values[i].name
        this.columns.push({ title: title, key: colName, dataIndex: colName })
        for (const j in this.result.table2d_values[i].values) {
          if (!this.tableData[j]) {
            this.tableData[j] = {}
          }
          this.tableData[j][colName] = this.result.table2d_values[i].values[j]
        }
      }
    },
    downloadTable() {
      const csvList = []
      let headLine = ''
      // 表头
      for (const i of this.result.table2d_values) {
        headLine = headLine + i.name + ','
      }
      csvList.push(headLine.slice(0, -1))
      // 表数据
      for (let i = 0; i < this.tableData.length; i++) {
        let line = ''
        for (let j = 0; j < this.result.table2d_values.length; j++) {
          line = line + this.result.table2d_values[j].values[i] + ','
        }
        csvList.push(line.slice(0, -1))
      }
      // encodeURIComponent解决中文乱码
      const uri =
        'data:text/csv;charset=utf-8,\ufeff' +
        encodeURIComponent(csvList.join('\n'))
      // 通过创建a标签实现
      const link = document.createElement('a')
      link.href = uri
      // 对下载的文件命名
      link.download = '结果表.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  watch: {
    result: function() {
      this.initOption()
      this.initTable()
    }
  },
  mounted() {
    this.initOption()
    this.initTable()
  }
}
</script>

<style scoped>
.rootDiv {
  margin: 2rem 2rem 1rem 2rem;
  padding-bottom: 1rem;
}
.resultPannel {
  background-color: white;
  margin: 2rem 0 1rem 0;
}
.resultHead {
  background-color: royalblue;
  /* background-color: #e6f7ff; */
  text-align: center;
  font-size: 1.2rem;
  /* font-weight: bold; */
  color: white;
  letter-spacing: 0.5rem;
  padding: 0.5rem 0 0.5rem 0;
}
.resultContent {
  padding: 1rem 1rem 1rem 1rem;
}
</style>
